module.exports = __webpack_public_path__ + "static/media/thumbnail.e4d7cd63.jpg";